import { render, staticRenderFns } from "./group-list.vue?vue&type=template&id=8910ba84"
import script from "./group-list.vue?vue&type=script&lang=js"
export * from "./group-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8910ba84')) {
      api.createRecord('8910ba84', component.options)
    } else {
      api.reload('8910ba84', component.options)
    }
    module.hot.accept("./group-list.vue?vue&type=template&id=8910ba84", function () {
      api.rerender('8910ba84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/security-group/user-binding/group-list.vue"
export default component.exports